// src/components/ui/Card.js
import React from "react";

// ✨ THE FIX: Wrap the component in React.forwardRef
const Card = React.forwardRef(({ children, className = "", ...props }, ref) => {
  const hasBackground = className.includes("bg-");
  const classes = `${hasBackground ? "" : "bg-white"} rounded-xl shadow-sm p-4 sm:p-6 ${className}`;
  return (
    <div className={classes} ref={ref} {...props}>
      {children}
    </div>
  );
});

export default Card;
